<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <div class="d-flex flex-row" style="width: 100%">
        <div style="width: 70%">
          <h1>Chi tiết đề xuất phí</h1>
        </div>
        <div style="width: 30%" class="text-right">
          <button
            type="button"
            @click="ReturnToList"
            class="btn btn-outline-secondary hc-37 mr-2 pt-2"
          >
            <i class="bx bx-arrow-back"></i>
            <span>&nbsp;</span>Quay lại
          </button>
        </div>
      </div>
    </div>

    <b-card>
      <b-row class="gx-2">
        <b-col md="12">
          <b-row>
            <b-col cols="12" md="4">
              <DetailInfo :info="merchant" :loading="loading" :keyNames="keyNames">
                <template #merchantName>
                  <b-link :href="`/list-mc/${merchant.customerId}`" size="sm" target="_blank">
                    {{ merchant.merchantName || '--' }}
                  </b-link>
                </template>
                <template #mccInfo>
                  <div>
                    {{ getBusinessName(merchant.mcc) }}
                  </div>
                </template>
                <template #mccDetails>
                  <div>
                    {{ merchant.mccDetail }}
                  </div>
                </template>
                <template #areaCity>
                  <div>
                    {{ merchant.areaCity ? merchant.areaCity : merchant.city }}
                  </div>
                </template>
                <template #sale>
                  <div>
                    {{ merchant.activeSaleName }} -
                    {{ merchant.activeSaleEmail }}
                  </div>
                </template>
              </DetailInfo>
              <div class="form-detail">
                <h1>
                  <strong class="h1-strong">Đề xuất phí</strong>
                </h1>
                <template v-if="!loading">
                  <template v-if="merchant">
                    <div
                      :class="
                        !merchant ? 'form-group form-row border-store' : 'form-group form-row'
                      "
                    >
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Tên:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ proFee.templateName }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Thời gian tạo:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ proFee.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Người tạo:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ proFee.createdByName }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">TG cập nhật:</p>
                        </label>
                        <div class="col-sm-8">
                          <div v-if="proFee.lastModifiedDate">
                            <p>
                              {{ proFee.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Người cập nhật:</p>
                        </label>
                        <div class="col-sm-8">
                          <div v-if="proFee.lastModifiedByName">
                            <p>{{ proFee.lastModifiedByName }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Trạng thái:</p>
                        </label>
                        <div class="col-sm-8">
                          <b-badge :variant="getStatusBadge(proFee.status)">
                            {{ getStatusName(proFee.status) }}
                          </b-badge>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Tên template gốc:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ proFee.templateName }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Ghi chú:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ proFee.note }}
                          </p>
                        </div>
                      </div>
                      <div class="col-sm-12 border-row">
                        <label for="" class="col-sm-4 col-form-label">
                          <p class="float-left">Cấp độ duyệt:</p>
                        </label>
                        <div class="col-sm-8">
                          <p>
                            {{ permApprove[proFee.permApprove] }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center text-info my-2">Không có dữ liệu</div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
              <div class="form-detail">
                <h1>
                  <strong class="h1-strong">Tệp đính kèm</strong>
                </h1>

                <template v-if="!loading">
                  <template v-if="paymentMethods?.length > 0">
                    <div
                      class="img-list mb-3"
                      v-for="(payment, index) in paymentMethods"
                      :key="payment.code"
                    >
                      <div>
                        <p class="text-primary font-bold font-size-14">
                          {{ paymentMethodsKey[payment.code] }}
                        </p>
                        <ul
                          v-viewer
                          class="m-0"
                          v-if="payment.filesUpload && payment.filesUpload.length > 0"
                        >
                          <li
                            class="p-1 item-img"
                            v-for="(item, index) in payment.filesUpload"
                            :key="`img-${index}`"
                          >
                            <a href="javascript:void(0)">
                              <img :src="item" alt="payment-type-image" />
                            </a>
                          </li>
                        </ul>
                        <div v-else>
                          <div class="text-center text-info my-2">Không có dữ liệu</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="spinner-center">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
              </div>
            </b-col>
            <b-col cols="12" md="8">
              <div v-if="!loading">
                <div
                  v-for="(payment, index) in paymentMethods"
                  :key="payment.code"
                  class="form-detail"
                >
                  <h1>
                    <strong class="h1-strong">{{ paymentMethodsKey[payment.code] }}</strong>
                  </h1>

                  <template v-if="!loading">
                    <template v-if="payment?.transactions?.length > 0">
                      <div class="font-size-16 font-medium" v-if="payment?.code !== 'QR'">
                        {{ transactionMethod[transactions] }}
                      </div>
                      <b-table
                        class="table-fee"
                        bordered
                        hover
                        head-variant="light"
                        fixed
                        show-empty
                        responsive
                        sticky-header
                        :items="payment.transactions"
                        :fields="fieldsTable"
                      >
                        <template #cell(amount)="{ item }">
                          <span class="text-orange">
                            {{ item.minAmountProposal | formatToMillion }} -
                            {{ item.maxAmountProposal | formatToMillion }}
                          </span>
                          <span>{{ ' triệu' }}</span>
                        </template>
                        <template #cell(feePerTransaction)="{ item }">
                          <span class="text-muted">
                            {{ item.feePerTransaction }}
                          </span>
                        </template>
                        <template #cell(feePerTransactionProposal)="{ item }">
                          <span :class="getColorClass(item)">
                            {{ item.feePerTransactionProposal }}
                          </span>
                        </template>
                        <template #cell(feeAmount)="{ item }">
                          <span class="text-orange">
                            {{ item?.minFee?.toLocaleString() ?? 0 }}
                            -
                            {{ item?.maxFee?.toLocaleString() ?? 0 }}
                          </span>
                          <span>{{ ' VNĐ' }}</span>
                        </template>
                      </b-table>
                      <b-card>
                        <div class="d-flex justify-content-between mt-2">
                          <div></div>
                          <div>
                            <div class="mb-1">
                              <span class="text-muted">Sản lượng GD: </span
                              ><span class="text-danger"
                                >{{ payment.totalMinTransaction.toLocaleString() }}
                                -
                                {{ payment.totalMaxTransaction.toLocaleString() }}</span
                              ><span class="text-muted"> VNĐ/ tháng</span>
                            </div>
                            <div>
                              <span class="text-muted">Phí tạm tính: </span
                              ><span class="text-orange"
                                >{{ payment.feeMinTransaction.toLocaleString() }}
                                -
                                {{ payment.feeMaxTransaction.toLocaleString() }}</span
                              ><span class="text-muted"> VNĐ/ tháng</span>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </template>
                    <template v-else>
                      <div v-if="payment?.code === 'QR'" class="text-center text-info my-2">
                        Không có dữ liệu
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="spinner-center">
                      <b-spinner class="align-middle" />
                    </div>
                  </template>

                  <template v-if="!loading">
                    <template v-if="payment?.installments?.length > 0">
                      <div class="mt-3 font-medium font-size-16">
                        {{ transactionMethod[installments] }}
                      </div>
                      <b-table
                        class="table-fee"
                        bordered
                        hover
                        head-variant="light"
                        fixed
                        show-empty
                        responsive
                        sticky-header
                        :items="payment.installments"
                        :fields="fieldsTable"
                      >
                        <template #cell(amount)="{ item }">
                          <span class="text-orange">
                            {{ item.minAmountProposal | formatToMillion }} -
                            {{ item.maxAmountProposal | formatToMillion }}
                          </span>
                          <span>{{ ' triệu' }}</span>
                        </template>
                        <template #cell(feePerTransaction)="{ item }">
                          <span class="text-muted">
                            {{ item.feePerTransaction }}
                          </span>
                        </template>
                        <template #cell(feePerTransactionProposal)="{ item }">
                          <span :class="getColorClass(item)">
                            {{ item.feePerTransactionProposal }}
                          </span>
                        </template>
                        <template #cell(feeAmount)="{ item }">
                          <span class="text-orange"
                            >asdf
                            {{ item?.minFee?.toLocaleString() ?? 0 }}
                            -
                            {{ item?.maxFee?.toLocaleString() ?? 0 }}
                          </span>
                          <span>{{ ' VNĐ' }}</span>
                        </template>
                      </b-table>
                    </template>
                  </template>
                  <template v-else>
                    <div class="spinner-center">
                      <b-spinner class="align-middle" />
                    </div>
                  </template>

                  <template v-if="!loading">
                    <template v-if="payment?.installmentPerPeriods?.length > 0">
                      <div class="mt-3 font-medium font-size-16">
                        {{ transactionMethod[installmentPerPeriods] }}
                      </div>
                      <b-table
                        class="table-fee"
                        bordered
                        hover
                        head-variant="light"
                        fixed
                        show-empty
                        responsive
                        sticky-header
                        :items="payment.installmentPerPeriods"
                        :fields="fieldsTableInstallment"
                      >
                        <template #cell(logo)="{ item }">
                          <div class="text-center">
                            <img class="logo-bank" :src="item.logo" alt="img-logo" />
                          </div>
                        </template>
                        <template #cell(amount)="{ item }">
                          <span class="text-orange">
                            {{ item.minAmount | formatToMillion }}
                            <!--                            - -->
                            <!--                            {{ item.maxAmount | formatToMillion }}-->
                          </span>
                          <span>{{ ' triệu' }}</span>
                        </template>
                        <template #cell(3month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '3') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '3')">{{
                            getRateProposal(item.listPeriod, '3')
                          }}</span>
                        </template>
                        <template #cell(6month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '6') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '6')">{{
                            getRateProposal(item.listPeriod, '6')
                          }}</span>
                        </template>
                        <template #cell(9month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '9') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '9')">{{
                            getRateProposal(item.listPeriod, '9')
                          }}</span>
                        </template>
                        <template #cell(12month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '12') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '12')">{{
                            getRateProposal(item.listPeriod, '12')
                          }}</span>
                        </template>
                        <template #cell(18month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '18') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '18')">{{
                            getRateProposal(item.listPeriod, '18')
                          }}</span>
                        </template>
                        <template #cell(24month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '24') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '24')">{{
                            getRateProposal(item.listPeriod, '24')
                          }}</span>
                        </template>
                        <template #cell(36month)="{ item }">
                          <span class="text-muted">{{ getRate(item.listPeriod, '36') }}</span>
                          <br />
                          <span :class="getColorListPeriod(item.listPeriod, '36')">{{
                            getRateProposal(item.listPeriod, '36')
                          }}</span>
                        </template>
                        <!--                        <template #cell(feeAmount)="{ item }">-->
                        <!--                          <span class="text-orange">-->
                        <!--                            {{-->
                        <!--                              calcFeeAmount(-->
                        <!--                                item.rate,-->
                        <!--                                item.minAmount-->
                        <!--                              )-->
                        <!--                            }}-->
                        <!--                            - -->
                        <!--                            {{-->
                        <!--                              calcFeeAmount(-->
                        <!--                                item.feePerTransactionProposal,-->
                        <!--                                item.maxAmount-->
                        <!--                              )-->
                        <!--                            }}-->
                        <!--                          </span>-->
                        <!--                          <span>{{ ' VNĐ' }}</span>-->
                        <!--                        </template>-->
                      </b-table>

                      <b-card>
                        <div class="d-flex justify-content-between mt-2">
                          <div></div>
                          <div>
                            <div class="mb-1">
                              <span class="text-muted">Sản lượng GD: </span
                              ><span class="text-danger"
                                >{{ payment.totalMinInstallmentPerPeriod.toLocaleString() }}
                                -
                                {{ payment.totalMaxInstallmentPerPeriod.toLocaleString() }}</span
                              ><span class="text-muted"> VNĐ/ tháng</span>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </template>
                  </template>
                  <template v-else>
                    <div class="spinner-center">
                      <b-spinner class="align-middle" />
                    </div>
                  </template>
                </div>
              </div>
              <div v-else class="spinner-center">
                <b-spinner class="align-middle" />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import DetailInfo from '@/components/cskh/DetailInfo'
  import {
    getConfigProposalFee,
    getDetailProposalFee,
    MerchantService,
  } from '@/services/merchant.service'
  import { CommonService } from '@/services/common.service'

  const statusMapping = {
    NEW: 'primary',
    DRAFT: 'secondary',
    CANCELED: 'danger',
    LIVE: 'success',
  }

  const fieldsTable = [
    { key: 'issuerName', label: 'Tên' },
    { key: 'feePerTransaction', label: 'Mức phí gốc' },
    { key: 'feePerTransactionProposal', label: 'Mức phí đề xuất' },
    { key: 'amount', label: 'Sản lượng (tháng)' },
    { key: 'feeAmount', label: 'Tiền phí (tháng)' },
  ]

  const fieldsTableInstallment = [
    { key: 'logo', label: 'Logo' },
    { key: 'bankName', label: 'Ngân hàng' },
    { key: '3month', label: '3 tháng' },
    { key: '6month', label: '6 tháng' },
    { key: '9month', label: '9 tháng' },
    { key: '12month', label: '12 tháng' },
    { key: '18month', label: '18 tháng' },
    { key: '24month', label: '24 tháng' },
    { key: '36month', label: '36 tháng' },
    { key: 'amount', label: 'Sản lượng tối thiểu (tháng)' },
    // { key: 'feeAmount', label: 'Tiền phí (tháng)' }
  ]

  const transactions = 'TRANSACTIONS'
  const installmentPerPeriods = 'INSTALLMENT_PER_PERIODS'
  const installments = 'INSTALLMENTS'

  export default {
    components: {
      DetailInfo,
    },
    data() {
      return {
        transactions,
        installmentPerPeriods,
        installments,
        fieldsTable,
        fieldsTableInstallment,
        proposalFeeStatus: [],
        permApprove: {},
        transactionMethod: {},
        isOpen: false,
        loading: false,
        id: '',
        proFee: {},
        paymentMethods: [],
        paymentMethodsKey: {},
        keyNames: [
          { key: 'merchantName', label: 'Tên merchant' },
          { key: 'email', label: 'Email' },
          { key: 'mccInfo', label: 'Ngành nghề' },
          { key: 'mccDetails', label: 'Ngành nghề chi tiết' },
          { key: 'areaCity', label: 'Tỉnh/thành' },
          { key: 'sale', label: 'NVCS' },
        ],
        merchant: '',
        businessFields: [],
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
      }
    },

    filters: {},

    async created() {
      this.id = this.$router.currentRoute.params.id
      await this.configSystem()
      await this.getConfig()
    },

    mounted() {
      if (!this.dataPermission.includes('')) {
        this.toggleSideBar()
        this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            // size: 'sm',
            // buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(value => {
            // chuyển trang
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatusName() {
        return id => {
          const status = this.proposalFeeStatus.find(status => status.id === id)
          return status ? status.text : 'Mới tạo'
        }
      },
      getStatusBadge() {
        return id => {
          const status = this.proposalFeeStatus.find(status => status.id === id)
          return status ? status.badge : 'primary'
        }
      },
      getBusinessName() {
        return code => {
          const businessField = this.businessFields.find(field => field.code === code)
          return businessField ? businessField.name : '--'
        }
      },
      calcFeeAmount() {
        return (fee, amount) => {
          if (!fee || !amount) return '0'
          return Math.round((fee * amount) / 100).toLocaleString()
        }
      },
      getRate() {
        return (listPeriod, period) => {
          const periodData = listPeriod.find(p => p.period === period)
          return periodData ? (periodData.rate ? periodData.rate : '0') : ''
        }
      },
      getRateProposal() {
        return (listPeriod, period) => {
          const periodData = listPeriod.find(p => p.period === period)
          return periodData ? (periodData.rateProposal ? periodData.rateProposal : '') : ''
        }
      },
      getColorClass() {
        return item => {
          const difference = (item?.feePerTransaction - item?.feePerTransactionProposal).toFixed(2)
          if (difference <= item?.limitGreen) {
            return 'text-green'
          } else if (difference <= item?.limitOrange) {
            return 'text-orange'
          } else if (difference <= item?.limitRed) {
            return 'text-red'
          } else {
            return ''
          }
        }
      },
      getColorListPeriod() {
        return (listPeriod, period) => {
          const periodData = listPeriod.find(p => p.period === period)
          const difference = (periodData?.rate - periodData?.rateProposal).toFixed(2)
          if (difference <= periodData?.limitGreen) {
            return 'text-green'
          } else if (difference <= periodData?.limitOrange) {
            return 'text-orange'
          } else if (difference <= periodData?.limitRed) {
            return 'text-red'
          } else {
            return ''
          }
        }
      },
    },

    methods: {
      ReturnToList() {
        this.$router.push(`/proposal-fee`)
      },
      async loadData() {
        try {
          this.loading = true
          const res = await getDetailProposalFee(this.id)

          this.proFee = res.data
          const merchantRes = await MerchantService.merchantDetail({
            customerId: res.data?.customerId,
          })
          this.merchant = merchantRes.data
          this.paymentMethods = res.data?.paymentMethods
          this.loading = false
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          this.loading = false
        } finally {
          this.loading = false
        }
      },
      toggleSideBar() {
        this.$store.commit('dom/SET_SIDEBAR_STATUS', !this.isOpen)
      },
      async configSystem() {
        try {
          this.loading = true
          const response = await getConfigProposalFee()
          if (response.code === 1000) {
            this.proposalFeeStatus = Object.keys(response.data.proposalFeeStatus).map(key => ({
              id: key,
              text: response.data.proposalFeeStatus[key],
              badge: statusMapping[key],
            }))

            this.paymentMethodsKey = response.data?.paymentMethods
            this.proposalFeeStatus.unshift({ id: '0', text: 'Tất cả' })
            this.permApprove = response.data?.permApprove
            this.transactionMethod = response.data?.transactionMethod
          } else {
            this.showToastError(response.message || 'Có lỗi xảy ra')
          }
          this.loading = false
        } catch (e) {
          this.showToastError(e.response?.data?.message ? e.response.data.message : e.message)
          this.loading = false
        }
      },
      async getConfig() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.businessFields = data.data.businessFields
            }
          })
          .catch(e => {
            this.showToastError(e.response?.data?.message ? e.response.data.message : e.message)
          })
      },
    },
  }
</script>

<style scoped>
  .form-detail {
    min-height: 120px;
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  h1 {
    border-bottom: none;
  }

  .h1-strong {
    border-left: 3px solid #13569f;
    padding-left: 5px;
    font-size: larger;
  }
  .img-list {
    position: relative;
    ul {
      .item-img {
        width: 108px;
        a {
          border: 2px solid #dcdcdc;
        }
        span {
          cursor: pointer;
          display: none;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
        &:hover span {
          display: block;
        }
      }
    }
  }
  .text-orange {
    color: rgba(225, 135, 0, 1);
  }
  .text-red {
    color: rgba(222, 0, 0, 1);
  }
  .text-green {
    color: rgba(0, 146, 53, 1);
  }
  .border-row {
    border-bottom: 2px dashed #edf1fa;
    display: flex;
  }
  .table-fee {
    max-height: 300px;
    min-height: unset !important;
  }
  .logo-bank {
    width: 60px;
  }

  .form-detail h1 {
    width: unset;
  }
</style>
